export const TenantsTableConf = [
  {
    field: 'companyName',
    title: 'Company Name'
  },
  {
    field: 'status',
    title: 'Status'
  },
  {
    field: 'tm',
    title: 'TM'
  },
  {
    field: 'ps',
    title: 'PS'
  },
  {
    field: 'plan',
    title: 'Pricing Plan'
  },

  {
    field: 'billingCycle',
    title: 'Billing Cycle'
  },
  {
    field: 'arr',
    title: 'ARR'
  },
  {
    field: 'coupon',
    title: 'Coupon'
  },
  {
    field: 'firstPaymentDate',
    title: 'Created Date'
  }
];
